import * as React from 'react';
import SupplierForgotPasswordForm from '../supplier_forgot_password_form/SupplierForgotPasswordForm';
import { Layout, Row, Col } from 'antd';

const style = require('./SupplierForgotPasswordPage.less');
const style2 = require('../../styles/blah.less');
const { Content } = Layout;

export default class SupplierForgotPasswordPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<Content
				className="supplierForgotPasswordPage"
				style={{
					height: '100vh',
					display: 'flex',
					backgroundColor: 'rgb(16, 35, 40)',
					alignItems: 'center',
				}}
			>
				{/*<BackTop/>*/}
				<Row
					style={{
						maxWidth: 800,
						boxShadow: 'rgba(0,0,0,0.5) 10px 10px 50px',
						width: '100%',
						margin: 'auto',
					}}
				>
					<Col sm={24} md={10}>
						<div style={{ background: 'rgb(38, 111, 131)', padding: 40, height: '100%' }}>
							<div
								style={{
									width: '100%',
									height: 80,
									backgroundSize: 'contain',
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'center',
									backgroundImage: `url('https://s3.amazonaws.com/emptor-data-assets/images/openwrench-logos/openwrenchlogo-white-fieldservice.png')`,
								}}
							/>
						</div>
					</Col>
					<Col sm={24} md={14}>
						<div style={{ padding: '56px 40px', background: 'white' }}>
							<h4 style={{ marginBottom: 24 }}>Reset password</h4>
							<SupplierForgotPasswordForm email="" />
						</div>
					</Col>
				</Row>
			</Content>
		);
	}
}
